module.exports = __webpack_public_path__ + "assets/img/c292-nc.svg";